import { gql } from '@apollo/client';
import TENANT_MANUFACTURER from 'api/fragments/TENANT_MANUFACTURER';
const SET_MANUFACTURER_NON_WORKING_DAYS = gql `
  ${TENANT_MANUFACTURER}
  mutation SetManufacturerNonWorkingDays(
    $manufacturerId: ID!
    $nonWorkingDays: [ManufacturerNonWorkingDayInput!]!
  ) {
    setManufacturerNonWorkingDays(
      manufacturerId: $manufacturerId
      nonWorkingDays: $nonWorkingDays
    ) {
      ...TenantManufacturerFragment
    }
  }
`;
export default SET_MANUFACTURER_NON_WORKING_DAYS;
